import React from 'react';

function Loading(){
  return (
    <div className='text-center'>
      <div className="loader-sm"></div>
    </div>
  );
}

export default Loading;